/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';

import Spinner from '../Spinner';

import Store from './model/JobStore';
import LogsTable from './LogsTable';

import { FaTasks } from 'react-icons/fa';
import { MdEventNote } from 'react-icons/md';

@inject('auth') @observer
class JobDetails extends Component {
    componentDidMount = () => {
        this.fetchData(this.props.match.params.id);
        // TODO sync asset updates
        // this.assetsStore.syncUpdate();
    };

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            // Id changes
            this.fetchData(nextProps.match.params.id);
        }
    };

    componentWillUnmount = () => {
        // this.assetsStore.unsyncUpdates();
    };

    fetchData = (id) => {
        this.store.fetchJob(id);
        this.store.fetchJobLogs(id);
    };

    @observable store = Store.fromJS(this.props.auth, []);

    render() {
        const { job, logs } = this.store;
        if (!job || !job.id) {
            return <Spinner />;
        }
        return (
            <section>
                <h1><FaTasks /> {job.name}</h1>

                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                            <table className="table table-sm table-striped">
                                <tbody>
                                    <tr>
                                        <th>
                                            <FormattedMessage id="Jobs.Id" defaultMessage="Id" />
                                        </th>
                                        <td><code>{job.externalId ? job.externalId : job.id}</code></td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage id="Jobs.Type" defaultMessage="Type" />
                                        </th>
                                        <td>{job.type}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage id="Jobs.Name" defaultMessage="Name" />
                                        </th>
                                        <td>{job.name}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage id="Jobs.Instance" defaultMessage="Instance" />
                                        </th>
                                        <td>{job.instance}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage id="Jobs.Status" defaultMessage="Status" />
                                        </th>
                                        <td>{job.status}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage id="Jobs.Priority" defaultMessage="Priority" />
                                        </th>
                                        <td>{job.priority}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage id="Jobs.Progress" defaultMessage="Progress" />
                                        </th>
                                        <td>{job.progress}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <h2>
                    <MdEventNote /> <FormattedMessage id="Jobs.Logs" defaultMessage="Logs" />
                </h2>
                <div className="row">
                    <div className="col-12">
                        <LogsTable logs={logs} />
                    </div>
                </div>

            </section>
        );
    }
}

JobDetails.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default injectIntl(JobDetails);
